export default __webpack_public_path__ + "datasets_logo.10659505.jpeg";